import { defineComponent, computed, createElementBlock, openBlock, createVNode } from 'vue';
import _sfc_main$1 from './basler-components.es116.js';
/* empty css                        */

const _hoisted_1 = { class: "media-image" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MediaImage",
  props: {
    media: {},
    cols: {},
    lazyload: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const sizes = computed(() => {
      if (props.media.sizes) {
        return props.media.sizes;
      }
      let cols = [10, 10, 12];
      if (props.cols && props.cols.length >= 3) {
        cols = props.cols;
      }
      return `(min-width: 1400px) calc(1400px / 12 * ${cols[0]}), (min-width: 992px) calc(100vw / 12 * ${cols[1]}), (min-width: 576px) calc(100vw / 12 * ${cols[2]}), 100vw`;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(_sfc_main$1, {
          image: props.media,
          sizes: sizes.value,
          lazyload: props.lazyload
        }, null, 8, ["image", "sizes", "lazyload"])
      ]);
    };
  }
});

export { _sfc_main as default };
